module.exports = __webpack_public_path__ + "img/c4.d0158b07.png";